import {
  DemurageDTO,
  SeaContainerViewDTO,
  SeaEventDTO,
  SeaLocationFlatDTO,
  SeaRouteDTO,
  SeaSealineNameDTO,
} from "../api/response.types";
import { SeaTransportTypesDTO } from "entities/shared/seaCard.types";
import { DateTimeDTO, SearchReferenceModel } from "entities/shared/shipmentCard.types";
import { Nullable, ValueOf } from "shared/lib/typeCheck.lib";

import { SeaTransformedEventDTO, TransformedDemurageDTO } from "../api/parser";

export type VesselModel = {
  name: string;
  voyage: string | null;
  pol: string | null;
  pod: string | null;
  etd: string | null;
  atd: string | null;
  eta: string | null;
  ata: string | null;
  predictiveETA: Nullable<DateTimeDTO>;
};

export type SealineNameModel = SeaSealineNameDTO;

export type LocationModel = Omit<SeaLocationFlatDTO, "country_code"> & {
  countryCode: string | null;
};

export type SeaSearchRouteModel = Omit<SeaRouteDTO, "transport_type"> & {
  transportType: ValueOf<typeof SeaTransportTypesDTO>;
};

export type ContainerModel = Omit<SeaContainerViewDTO, "size_type" | "iso_code"> & {
  sizeType: string | null;
  isoCode: string;
};

export type DemurageModel = Omit<DemurageDTO, "storage" | "demurrage" | "detention"> & {
  storage: DemurageDTO["storage"] & { freeDays: number; daysInCharge: number };
  demurrage: DemurageDTO["demurrage"] & { freeDays: number; daysInCharge: number };
  detention: DemurageDTO["detention"] & { freeDays: number; daysInCharge: number };
};

export type EventModel = SeaEventDTO;

export type SeaTransformedEventModel = Omit<SeaTransformedEventDTO, "events"> & {
  events: EventModel[];
};

export type TransformedDemurageModel = TransformedDemurageDTO;

export type SeaSearchOptions = {
  requestedReference?: SearchReferenceModel;
};
